import { createActions, handleActions } from 'redux-actions';
import selectors from './selectors';

const initialState = {
  userProfile: null,
};

const SET_USER_PROFILE = 'DESIGN_PRO/USER/SET_USER_PROFILE';

const actions = createActions({
  [SET_USER_PROFILE]: (userProfile) => ({ userProfile }),
});

const reducer = handleActions(
  {
    [SET_USER_PROFILE]: (state, action) => ({
      ...state,
      userProfile: action.payload.userProfile,
    }),
  },
  initialState,
);

export default {
  initialState,
  actions: actions.designPro.user,
  reducer,
  selectors,
};
